import { Store, Module, ActionContext } from "vuex";
import ListModule from "./list-module";
import ListState from "./list-state";
import Unit from "../entities/unit";
import UnitFileLine from "../entities/unit-file-line";
import Ajax from "../../lib/ajax";
import PageResult from "@/store/entities/page-result";
import appconst from "./../../lib/appconst";

interface UnitState extends ListState<Unit> {
  editUnit: Unit;
  permissions: Array<string>;
  unitsForSelect: Unit[];
  unitsOfClientForSelect: Unit[];
}
class UnitModule extends ListModule<UnitState, any, Unit> {
  state = {
    totalCount: 0,
    currentPage: 1,
    pageSize: 10,
    list: new Array<Unit>(),
    loading: false,
    editUnit: new Unit(),
    permissions: new Array<string>(),
    unitsForSelect: new Array<Unit>(),
    unitsOfClientForSelect: new Array<Unit>(),
  };
  actions = {
    async getAll(context: ActionContext<UnitState, any>, payload: any) {
      context.state.loading = true;
      let reponse = await Ajax.get("/api/services/app/Unit/GetAll", {
        params: payload.data,
      });
      context.state.loading = false;
      let page = reponse.data.result as PageResult<Unit>;
      context.state.totalCount = page.totalCount;
      context.state.list = page.items;
    },
    async create(context: ActionContext<UnitState, any>, payload: any) {
      await Ajax.post("/api/services/app/Unit/Create", payload.data);
    },
    async update(context: ActionContext<UnitState, any>, payload: any) {
      await Ajax.put("/api/services/app/Unit/Update", payload.data);
    },
    async delete(context: ActionContext<UnitState, any>, payload: any) {
      await Ajax.delete("/api/services/app/Unit/Delete?Id=" + payload.data.id);
    },
    async get(context: ActionContext<UnitState, any>, payload: any) {
      let reponse = await Ajax.get(
        "/api/services/app/Unit/Get?Id=" + payload.id
      );
      return reponse.data.result as Unit;
    },
    async getAllPermissions(context: ActionContext<UnitState, any>) {
      let reponse = await Ajax.get("/api/services/app/Unit/getAllPermissions");
      context.state.permissions = reponse.data.result.items;
    },
    async uploadImportUnitFile(
      context: ActionContext<UnitState, any>,
      data: any
    ) {
      let reponse = await Ajax.post(
        "/api/services/app/UnitFile/ImportUnit",
        data
      );
      return reponse.data.result;
    },
    async importUnit(context: ActionContext<UnitState, any>, payload: any) {
      let reponse = await Ajax.put(
        "/api/services/app/Unit/ImportUnit",
        payload.data
      );
      return reponse.data.result as Array<UnitFileLine>;
    },
    async getListForSelect(context: ActionContext<UnitState, any>) {
      let reponse = await Ajax.get("/api/services/app/Unit/GetUnitsForSelect");
      context.state.unitsForSelect = reponse.data.result.items as Unit[];
    },
    async processNotifier(
      context: ActionContext<UnitState, any>,
      payload: any
    ) {
      if (payload.data != null) {
        let unit = payload.data as Unit;
        context.state.list.push(unit);
      }
    },
    async export(context: ActionContext<UnitState, any>, payload: any) {
      window.open(
        `${
          appconst.remoteServiceBaseUrl
        }export/exportUnits${abp.utils.buildQueryString(
          Object.keys(payload.data).map((key) => {
            return {
              name: key,
              value: payload.data[key],
            };
          }),
          true
        )}`,
        "_blank"
      );
    },
    async getUnitsOfClientForSelect(
      context: ActionContext<UnitState, any>,
      payload: any
    ) {
      let reponse = await Ajax.get(
        "/api/services/app/Unit/GetUnitsOfClientForSelect",
        { params: payload.data }
      );
      context.state.unitsOfClientForSelect = reponse.data.result
        .items as Unit[];
    },
  };
  mutations = {
    setCurrentPage(state: UnitState, page: number) {
      state.currentPage = page;
    },
    setPageSize(state: UnitState, pagesize: number) {
      state.pageSize = pagesize;
    },
    edit(state: UnitState, role: Unit) {
      state.editUnit = role;
    },
  };
}
const unitModule = new UnitModule();
export default unitModule;
